import { Grid, Switch, Text } from '@mantine/core';
import LabeledSlider from '../LabeledSlider';

const NewProductsRuleSelector = ({ productFeed, handleChange }) => {
  return (
    <Grid align="center" mb="sm">
      <Grid.Col span={{ base: 12, sm: 4 }}>
        <Text fw={500}>Freshness filter</Text>
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 8 }}>
        <Switch
          onChange={(value) => {
            handleChange({ target: { name: 'optionsEnableDays', value: value } });
          }}
          checked={productFeed.options?.days !== undefined}
        />
        {productFeed.options?.days !== undefined && (
          <Grid mt="sm">
            <Grid.Col span={12}>
              <LabeledSlider
                min={1}
                max={30}
                step={1}
                value={productFeed.options.days}
                onChange={(value) => {
                  handleChange({ target: { name: 'optionsDays', value: value } });
                }}
              />
            </Grid.Col>
          </Grid>
        )}
      </Grid.Col>
    </Grid>
  );
};

export default NewProductsRuleSelector;
